import type { PayloadAction } from '@reduxjs/toolkit';
import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import storage from 'src/store/storage';

export const VAULT_LIST_DEFAULT_SORT = 'created:desc';
export const VAULT_LIST_DEFAULT_LIMIT = 20;

export interface VaultListFilterOptions {
  selectedFilters: string[];
  sort: string;
  limit: number;
}

const initialState: VaultListFilterOptions = {
  selectedFilters: [],
  sort: VAULT_LIST_DEFAULT_SORT,
  limit: VAULT_LIST_DEFAULT_LIMIT,
};

const vaultListFilterSlice = createSlice({
  name: 'vaultList/filterOptions',
  initialState,
  reducers: {
    setVaultListFilterOptions: (state, action: PayloadAction<Partial<VaultListFilterOptions>>) => {
      const { selectedFilters, sort, limit } = action.payload;
      if (selectedFilters !== undefined && Array.isArray(selectedFilters)) {
        state.selectedFilters = selectedFilters;
      }
      if (sort !== undefined && typeof sort === 'string') {
        state.sort = sort;
      }
      if (limit !== undefined && typeof limit === 'number') {
        state.limit = limit;
      }
    },
    resetVaultListFilterOptions: () => ({ ...initialState, selectedFilters: [] }),
  },
});

const persistConfig = {
  key: 'vaultList/filter',
  storage,
  whitelist: ['selectedFilters', 'sort', 'limit'],
};

export const vaultListFilterActions = vaultListFilterSlice.actions;

export default combineReducers({
  filter: persistReducer(persistConfig, vaultListFilterSlice.reducer),
});
